/*global _ */
import ReservationMixin from '../../../../components/_mixins/event-reservation'
import AxeReservationMixin from '../../reseravtion'

import Timeslot from './timeslot'

const components = {
  Timeslot
}

export default {
  name: 'timeslot-selector-box',
  mixins: [ReservationMixin, AxeReservationMixin],
  components,
  computed: {
    allSlots() {
      return this.retrievedTimeslots
    },
    numRetrievedSlots() {
      return _.size(this.allSlots)
    },
    selectableSlots() {
      return _.omitBy(this.allSlots, slot =>  {
        return !slot.maxParticipants || !slot.tracks || !slot.tracks.length
      })
    },
    noRetrievedSlots() {
      return _.isEmpty(this.allSlots)
    },
    noSelectableSlotForDay() {
      return this.noRetrievedSlots || _.every(this.allSlots, slot => !slot.tracks || !slot.tracks.length)
    },
    numSelectableSlots() {
      return _.size(this.selectableSlots)
    },
    noSelectableSlots() {
      return _.isEmpty(this.selectableSlots)
    },
    hasSelectedSlot() {
      return !_.isEmpty(this.selectedSlots)
    },
  },
  watch: {
    duration() {
      const slots = this.parseSelectableSlots(_.cloneDeep(this.retrievedTimeslots))
      this.setRetrievedTimeslots(slots)
    },
    participants() {
      const slots = this.parseSelectableSlots(_.cloneDeep(this.retrievedTimeslots))
      this.setRetrievedTimeslots(slots)
    }
  }
}
